export default __webpack_public_path__ + "3d6959dccd952cd6aab557b71af715a4.ico";